import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getByRegister(registerId: string | number) {
  const response = await http.getData(`/register/${registerId}/discharge-planning`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id: number, data) {
  const response = await http.putData(`/discharge-planning/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function addEdukasi(id: number, data) {
  const response = await http.postData(`/discharge-planning/${id}/edukasi`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function updateEdukasi(id: number, edukasiId: number, data) {
  const response = await http.putData(`/discharge-planning/${id}/edukasi/${edukasiId}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function deleteEdukasi(id: number, edukasiId: number) {
  const response = await http.deleteData(`/discharge-planning/${id}/edukasi/${edukasiId}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signPpaEdukasi(id: number, edukasiId: number, data) {
  const response = await http.postData(`/discharge-planning/${id}/edukasi/${edukasiId}/sign-ppa`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signPerawat(id: number, data) {
  const response = await http.postData(`/discharge-planning/${id}/sign-perawat`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signDpjp(id: number, data) {
  const response = await http.postData(`/discharge-planning/${id}/sign-dpjp`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function markPasien(id: number, data) {
  const response = await http.postData(`/discharge-planning/${id}/mark-pasien`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function finalize(id: number) {
  const response = await http.postData(`/discharge-planning/${id}/finalize`, {}).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

function print(id: number) {
  window.open(`${http.getAPI()}/discharge-planning/${id}/pdf`, "_blank");
}

export default {
  getByRegister,
  update,
  addEdukasi,
  updateEdukasi,
  deleteEdukasi,
  signPpaEdukasi,
  signPerawat,
  signDpjp,
  markPasien,
  finalize,
  print
};
